import { render, staticRenderFns } from "./ElectricityMeter.vue?vue&type=template&id=637edbff&scoped=true&"
import script from "./ElectricityMeter.vue?vue&type=script&lang=ts&"
export * from "./ElectricityMeter.vue?vue&type=script&lang=ts&"
import style0 from "./ElectricityMeter.vue?vue&type=style&index=0&id=637edbff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637edbff",
  null
  
)

export default component.exports